var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgWaterDropOutline = function SvgWaterDropOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.983 2.5C17.354 2.5 24 10.384 24 16c0 5.523-4.477 10-10 10S4 21.523 4 16c0-5.618 6.617-13.5 9.983-13.5zm0 2c-.652 0-2.738 1.565-4.482 3.643C7.338 10.72 6 13.56 6 16a8 8 0 1016 0c0-2.439-1.344-5.278-3.517-7.855-1.75-2.078-3.846-3.645-4.5-3.645z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjk4MzMgMi41QzE3LjM1NCAyLjUgMjQgMTAuMzgzOSAyNCAxNkMyNCAyMS41MjI4IDE5LjUyMjkgMjYgMTQgMjZDOC40NzcxNSAyNiA0IDIxLjUyMjggNCAxNkM0IDEwLjM4MjEgMTAuNjE2NyAyLjUgMTMuOTgzMyAyLjVaTTEzLjk4MzMgNC41QzEzLjMzMDggNC41IDExLjI0NTIgNi4wNjU0OCA5LjUwMTI3IDguMTQyOTVDNy4zMzggMTAuNzE5OSA2IDEzLjU1OTggNiAxNkM2IDIwLjQxODMgOS41ODE3MiAyNCAxNCAyNEMxOC40MTgzIDI0IDIyIDIwLjQxODMgMjIgMTZDMjIgMTMuNTYxMyAyMC42NTYyIDEwLjcyMjIgMTguNDgzMyA4LjE0NDUzQzE2LjczMjEgNi4wNjcxMyAxNC42Mzc0IDQuNSAxMy45ODMzIDQuNVoiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgWaterDropOutline as ReactComponent };